import { TmFormBuilderError } from '@/core/error/tmFormBuilderError'

export class TmFormBuilderFieldNotFoundError extends TmFormBuilderError {
  public name = 'TmFormBuilderFieldNotFoundError'
}
